import React from "react";
import moment from "moment";
import parsePhoneNumber from "libphonenumber-js";
import sec2time from "../../../../utils/Functions";
import CallLogRow from "../../../../design-system/components/telephony/CallLogRow";

function phoneView(number) {
  const phoneNumber = parsePhoneNumber("+" + number);
  if (!phoneNumber) return { text: number, country: null };
  return {
    text: phoneNumber.country === "FR" ? phoneNumber.formatNational() : phoneNumber.formatInternational(),
    country: /^[A-Z]{2}$/.test(phoneNumber.country || "") ? phoneNumber.country : null,
  };
}

function directionOf(obj) {
  if (obj.context === "out") return "outgoing";
  const state = obj.last_state;
  if (state === "VOICEMAIL" || state === "VOICEMAIL_ANSWERED") return "voicemail";
  if (["ANSWERED", "ANNOUNCE_ANSWERED", "BLIND_TRANSFERED"].includes(state)) return "incoming";
  return "missed";
}

function contactName(obj) {
  return (
    obj.users?.name?.formatted ||
    obj.contact?.concat_name ||
    obj.ivrs?.name ||
    ""
  );
}

export default function CallHistoryTab({ obj }) {
  const remote = obj.context === "out" ? obj.onumber : obj.anumber || obj.bnumber;
  const phone = phoneView(remote);
  const name = contactName(obj);

  return (
    <CallLogRow
      direction={directionOf(obj)}
      number={phone.text || remote || ""}
      flag={
        phone.country ? (
          <img
            alt=""
            style={{ height: 14, width: "auto", display: "block", borderRadius: 2 }}
            src={`https://webcdn.ringover.com/app/img/new_flags_svg/${phone.country}.svg`}
          />
        ) : null
      }
      line={obj.ivrs?.name}
      contact={{ name, avatar: obj.contact?.picture }}
      timestamp={moment(obj.call_start_time).format("DD/MM/YYYY, HH:mm")}
      stats={
        obj.incall_duration
          ? [{ icon: "phone", label: sec2time(obj.incall_duration) }]
          : []
      }
      tags={(obj.tags || []).map(tag => ({ label: tag.name || tag.label || String(tag) }))}
    />
  );
}
